import React from 'react'
import "./PhysicalTherapy.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function PhysicalTherapy() {

   return (
      <>
         <div className="container">
            <CustomTitle title="الادوية" />

            <h2 className='main-header mt-5 pt-5'>PhysicalTherapy Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
